export default {
  title: {
    id: 'buyback_options_addresses_tab_title',
    defaultMessage: 'Addresses for Trade-in purchases',
  },
  description: {
    id: 'buyback_options_addresses_tab_description',
    defaultMessage:
      'Need to add a new address or designate an existing one for your Trade-in purchases? Set Trade-in address rules over on the Sales side of your Back Office. If you don’t, Trade-in purchases will be automatically shipped to your default address. When you’re done, head back to the Trade-in side to continue working.',
  },
  cta: {
    id: 'buyback_options_addresses_tab_CTA',
    defaultMessage: 'Go to your new address book',
  },
}
